import PendingDeduction from "../../../views/PendingDeduction";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const PendingDeductionRoutes = [
  {
    menuName: MenuNames.PENDING_DEDUCTION,
    path: "/pending-deduction",
    component: PendingDeduction,
    exact: true,
  },
];

export default PendingDeductionRoutes;
